import BaseCommand from "@/models/api/commands/BaseCommand";

export class AddServicePackageCommand extends BaseCommand {
  CommandName = "AddServicePackage";
  Command: string;
  constructor(sessionId: string, operationId: string, servicePackageId: string) {
    super(sessionId, operationId);
    this.Command = servicePackageId;
  }
}
